import type { BillingProviderConfigMap } from "../../../providers/types.ts";
import type { AthenaBillingCatalogConfig } from "../../../types.ts";
import { normalizeAthenaBillingCatalog } from "../catalog/normalize.ts";
import { firstConfiguredMollieProvider } from "./connection-binding.ts";
import { normalizeBillingProviderConfig } from "./config.ts";
import { createMollieBillingProviderRuntime } from "./mollie/runtime.ts";
import { BillingProviderRegistry } from "./registry.ts";
import { createStripeBillingProviderRuntime } from "./stripe/runtime.ts";

export function createBillingProviderRegistry(
	configured?: BillingProviderConfigMap,
	catalog?: AthenaBillingCatalogConfig,
): BillingProviderRegistry {
	const fallbackMollie = firstConfiguredMollieProvider(configured);
	const normalized = normalizeBillingProviderConfig(
		configured?.mollie == null && fallbackMollie != null
			? { ...configured, mollie: fallbackMollie }
			: configured,
	);
	const athenaCatalog = normalizeAthenaBillingCatalog(catalog);
	const runtimes = [];
	if (normalized.mollie != null) {
		runtimes.push(
			createMollieBillingProviderRuntime(normalized.mollie, athenaCatalog),
		);
	}
	if (normalized.stripe != null) {
		runtimes.push(createStripeBillingProviderRuntime(normalized.stripe));
	}
	return new BillingProviderRegistry(runtimes);
}
